import { ExamplePageTemplate } from "./components";
import { healthcareConfig } from "./configs/exampleConfigs";

const HealthcareExample = () => {
  return (
    <ExamplePageTemplate
      backgroundColor={healthcareConfig.backgroundColor}
      chatButtonColor={healthcareConfig.chatButtonColor}
      chatButtonIcon={healthcareConfig.chatButtonIcon}
      header={healthcareConfig.header}
      hero={healthcareConfig.hero}
    >
      {healthcareConfig.content}
    </ExamplePageTemplate>
  );
};

export default HealthcareExample;